import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

export default function JSONDisplay({json, className}) {

    let isValidJSON = true;
    let prettyJsonStr;
    try {
        if (_.isString(json)) {
            prettyJsonStr = JSON.stringify(JSON.parse(json), null, 2);
        } else {
            prettyJsonStr = JSON.stringify(json, null, 2);
        }
    } catch {
        isValidJSON = false;
    }

    return (
        <>
            { isValidJSON &&
                <pre className={className}>{prettyJsonStr}</pre>
            }

            { !isValidJSON &&
                <pre className={className}>Invalid JSON: {json}</pre>
            }
        </>
    );
}

JSONDisplay.propTypes = {
    json: PropTypes.any,
    className: PropTypes.string
};
